import { LeaseOutboxRecordDto } from '../dtos/lease-outbox-record.dto';

/**
 * Lease outbox records response DTO
 */
export class LeaseOutboxRecordsResponse {
	records!: LeaseOutboxRecordDto[];
}
